$('.third-level-toggle').on('click', function(e) {
  e.preventDefault();
  $(this).parent('li').siblings('li').find('button, a').removeClass('toggled-nav');
  $(this).parent('li').siblings('li').find('ul').hide();
  
  $(this).toggleClass('toggled-nav');
  $(this).next('ul').toggle();
});

function productSlider(){
	$('.product-slick').each(function(){
		var options = $(this).attr('data-slider-options');
		options = JSON.parse(options);

    var responsive = [{
          breakpoint: 641,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }];
		$(this).slick(options).slick('slickSetOption', 'responsive', responsive, true);
	});
}
productSlider();


$('.instagram-feed-wrap').each(function (index, value) {
	var $target = $(this).find(".js-instafeed");
	var feed = new Instafeed({
		get: 'user',
		userId: $target.data('user'),
	  clientID: '2066092923.d90570a.137635e761814819a0dd0544182d00a4',
    limit: $target.data('count'),
    accessToken:  $target.data('access-token'),
    resolution: 'standard_resolution'
	});
	feed.run();
});

function process_slick_event(evt) {
  var _slick = $("#" + evt.target.id + " .product-slick");
  if(_slick.length){
    switch(evt.originalEvent.type){
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        //do thing here
        var options = _slick.attr('data-slider-options');
				options = JSON.parse(options);
				var responsive = [{
          breakpoint: 641,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }];
        _slick.slick(options).slick('slickSetOption', 'responsive', responsive, true);
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
document.addEventListener( 'DOMContentLoaded', function () {
  $(document).on( 'shopify:section:load shopify:section:unload', process_slick_event );
}, false );

$('a.colorbox').colorbox({
  maxHeight: "90%",
  maxWidth: "90%",
  fixed: true
});